const React = require('react')
const PropTypes = require('prop-types')
const _ = require('lib/underscore')
const locationDisplayName = require('module/user/helpers/location_display_name')
const log = require('log').create('headline') // eslint-disable-line


// string role => <Role />
function renderRole(role, i) {
    return (
        <span className="role" key={i}>{role}</span>
    )
}

// array of strings => [<Role />, <Role />, and <Role />]
function renderRoles(roles) {
    if (! roles || ! roles.length) return

    const tags = roles.map(renderRole)

    const output = []
    tags.forEach((role, i) => {
        // if list is more than one item and this is the last item, prefix with 'and '
        if (tags.length > 1 && i === tags.length - 1) output.push('and ')
        // output the item
        output.push(role)
        // if list is more than 2 items, append a comma to all but the last item
        if (tags.length > 2 && i < tags.length - 1) output.push(',')
        // if list is more than 1 item, append a space to all but the last item
        if (tags.length > 1 && i < tags.length - 1) output.push(' ')
    })

    return (
        <span className="roles">
            {output}
        </span>
    )
}


class Headline extends React.Component {

    renderHeadline() {
        const roles = this.renderRoles()
        const location = this.renderLocation()

        if (roles && location) {
            return (
                <h2 className="headline">
                    {roles} <span className="location">in {location}</span>
                </h2>
            )
        }

        if (roles) {
            return (
                <h2 className="headline">
                    {roles}
                </h2>
            )
        }

        if (location) {
            return (
                <h2 className="headline">
                    {location}
                </h2>
            )
        }

        return false
    }

    renderRoles() {
        const roles = _.pluck(this.props.user.roles, 'role').slice(0, 3)
        if (! roles.length) return false
        return renderRoles(roles)
    }

    renderLocation() {
        const location = _.first(this.props.user.locations)
        if (! location) return false

        const location_string = locationDisplayName(location)
        if (! location_string) return false

        return (
            <span className="location">
                {location_string}
            </span>
        )
    }

    render() {
        const headline = this.renderHeadline()
        if (! headline) return false

        return (
            <section>
                {headline}
            </section>
        )
    }

}

Headline.propTypes = {
    user: PropTypes.object.isRequired,
}

module.exports = Headline
